module.exports = __webpack_public_path__ + "img/addFile.b24bce98.png";